import Entity from '../entity'
export default class EstadoCampana extends Entity<number>{
    estado: string;
    descripcion: number
}